<template>
  <div>
    <UIExit label="Exit Personal Settings" :exit-url="defaultRedirect" />
    <router-view></router-view>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { TENANT_ROLES } from '@src/constants/user-roles-constants.js'
import ROUTE from '@/src/constants/route-constants.js'
import layoutConstants from '@src/constants/layout-constant.js'
import UIExit from '@src/components/UiElements/UIExit.vue'
import { ENV } from '@src/constants/general-constants.js'
import { FEATURES_ENVIRONMENT } from '@/src/services/.env'
export default {
  page: {
    title: 'Settings | User',
    meta: [
      {
        name: 'description',
        content: 'MyQampus User related Settings',
      },
    ],
  },
  components: {
    UIExit,
  },

  computed: {
    defaultRedirect() {
      const currentActiveRole = this.activeRole
      switch (currentActiveRole) {
        case TENANT_ROLES.SECTION_TEACHER:
          return ROUTE.ATTENDANCE.CAMPUS.PATH
        case TENANT_ROLES.GUARDIAN:
          return ROUTE.SUPPORT_QUERY.SUPPORT_QUERY.PATH
        case TENANT_ROLES.SECTION_STUDENT:
          return ROUTE.ATTENDANCE.SECTION.PATH
        case TENANT_ROLES.PICKUP_PERSON:
          return ROUTE.PICKUP_MANAGER.PATH
        default:
          return ROUTE.QUICK_ACTION.PATH
      }
    },
    ...mapState({
      activeRole: (state) => state.layout.activeRole,
    }),
  },
  created() {
    this.setLeftbarContent({
      back: '',
      customeHeader: 'left-bar-class-list',
      SHOW_SECTION_DROPDOWN_TO: layoutConstants.showSectionDropdownTo,
      SHOW_CLASS_DROPDOWN_TO: layoutConstants.showClassDropdownTo,
      routes: [
        ...(FEATURES_ENVIRONMENT === ENV.DEV
          ? [
              {
                id: '001',
                name: 'Profile Settings',
                role: ['super_admin', 'section_teacher', 'section_student', 'staff'],
                showChilds: false,
                childs: [
                  {
                    name: 'perosnal-info',
                    route: { name: 'perosnal-info' },
                  },
                  {
                    name: 'contact-info',
                    route: { name: 'contact-info' },
                  },
                  {
                    name: 'professional-info',
                    route: { name: 'professional-info' },
                  },
                  {
                    name: 'salary-info',
                    route: { name: 'salary-info' },
                  },
                ],
              },
            ]
          : []),

        {
          id: '002',
          name: 'Security Settings',
          role: [
            TENANT_ROLES.SUPER_ADMIN,
            TENANT_ROLES.SECTION_TEACHER,
            TENANT_ROLES.SECTION_STUDENT,
            TENANT_ROLES.GUARDIAN,
            TENANT_ROLES.CAMPUS_ADMIN,
            TENANT_ROLES.STAFF,
            TENANT_ROLES.PICKUP_PERSON,
          ],
          showChilds: false,
          childs: [
            {
              name: 'change-password',
              route: { name: 'change-password' },
            },
            {
              name: 'change-email',
              route: { name: 'change-email' },
            },
            {
              name: 'change-phone',
              route: { name: 'change-phone' },
            },
          ],
        },

        ...(FEATURES_ENVIRONMENT === ENV.DEV
          ? [
              {
                id: '004',
                name: 'Theme Settings',
                role: ['super_admin', 'section_teacher', 'section_student', 'staff'],
                route: { name: 'theme-settings' },
              },
            ]
          : []),
        {
          id: ROUTE.NOTIFICATION_PREFERENCES.ID,
          name: ROUTE.NOTIFICATION_PREFERENCES.NAME,
          role: [
            TENANT_ROLES.SUPER_ADMIN,
            TENANT_ROLES.CAMPUS_ADMIN,
            TENANT_ROLES.SECTION_TEACHER,
            TENANT_ROLES.SECTION_STUDENT,
            TENANT_ROLES.GUARDIAN,
            TENANT_ROLES.STAFF,
            TENANT_ROLES.PICKUP_PERSON,
          ],
          route: ROUTE.NOTIFICATION_PREFERENCES.PATH,
        },
      ],
    })
  },
  methods: {
    ...mapActions('layout', ['setLeftbarContent', 'modifyLeftBarDropdown']),
  },
}
</script>
